import { render } from "./AppHome.vue?vue&type=template&id=6dbcc616&scoped=true"
import script from "./AppHome.vue?vue&type=script&lang=js"
export * from "./AppHome.vue?vue&type=script&lang=js"

import "./AppHome.vue?vue&type=style&index=0&id=6dbcc616&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbcc616"]])

export default __exports__